import {MetadataForRestore} from 'notebook/mediocre/selection/block/MultiSelectListUtil';
import {TableIndex} from 'notebook/tables/TableConstants';
import TableUtil from 'notebook/tables/TableUtil';
import {NotePart} from 'notebook/util/NoteUtilConstants';

import {UnknownNoteLinkedGroup} from '../NoteLinkedGroupConstants';

type AnyMetadataForRestore = MetadataForRestore<TableIndex> | {selection: SelectionRestoreData} | null;

export function isMetadataForRestoreForContainedNotePart(
  metadataForRestore: AnyMetadataForRestore,
  notePart: NotePart
): metadataForRestore is MetadataForRestore<TableIndex> {
  if (
    metadataForRestore == null ||
    (metadataForRestore as MetadataForRestore<TableIndex>).multiSelectKey == null
  ) {
    return false;
  }
  return (
    TableUtil.getTableMultiSelectKey(notePart.cid) ===
    (metadataForRestore as MetadataForRestore<TableIndex>).multiSelectKey
  );
}

export function getMetadataForRestoreForGroup(
  group: UnknownNoteLinkedGroup,
  metadataForRestore: AnyMetadataForRestore
): MetadataForRestore<TableIndex> | null {
  for (const notePart of group.containedNoteParts) {
    if (isMetadataForRestoreForContainedNotePart(metadataForRestore, notePart)) {
      return metadataForRestore;
    }
  }
  return null;
}
